export type ThemeFontFamilyName = 'body' | 'heading';

export const Fonts: Record<ThemeFontFamilyName, string[]> = {
  body: ['Barlow', 'Arial', 'sans-serif'],
  heading: ['LL Sari Tab', 'Arial', 'sans-serif'],
};
